import { CHIPS_KEY, chipsSliceReducer } from '@/components/common/chips/slice';
import { ANALYTIC_KEY, analyticSliceReducer } from '@/modules/analytic/slice';
import {
    ANIMATION_KEY,
    animationSliceReducer,
} from '@/modules/animation/slice';
import { BET_GAME_KEY, betGameSliceReducer } from '@/modules/bet/game/slice';
import { BET_TABLE_KEY, tableBetSliceReducer } from '@/modules/betTable/slice';
import { GOOD_ROAD_KEY, goodRoadsSliceReducer } from '@/modules/goodRoad/slice';
import { LHOST_KEY, hostLiveSliceReducer } from '@/modules/hostLive/slice';
import {
    LOBBY_ROOM_KEY,
    lobbyRoomSliceReducer,
} from '@/modules/lobby/room/slice';
import {
    GAME_LIVE_KEY,
    LiveDataSliceReducer,
} from '@/modules/main/slice/liveData';
import {
    ROADMAP_TYPE_KEY,
    roadmapTypeSliceReducer,
} from '@/modules/roadmap/sedie/slice';
import {
    BJ2_HAND_KEY,
    bj2HandSliceReducer,
} from '@/modules/rwdGame/blackjack2/slice/handSlice';
import {
    BJ2_SEAT_KEY,
    bj2SeatSliceReducer,
} from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import { combineReducers } from 'redux';
import {
    BET_PLAYERS_KEY,
    betPlayersSliceReducer,
} from '../modules/bet/players/slice';
import { BET_ROOM_KEY, betRoomSliceReducer } from '../modules/bet/room/slice';
import { PCOUNT_KEY, countsSliceReducer } from '../modules/count/slice';
import { GAME_KEY, gameSliceReducer } from '../modules/games/slice';
import { PHOST_KEY, hostsSliceReducer } from '../modules/host/slice';
import { LOBBY_KEY, lobbySliceReducer } from '../modules/lobby/slice';
import mainReducer, { MAIN_KEY } from '../modules/main/slice';
import {
    GAME_POPUP_KEY,
    inGamePopupSliceReducer,
} from '../modules/popup/inGameSlice';
import { POPUP_KEY, popupSliceReducer } from '../modules/popup/slice';
import progressReducer, { PROGRESS_KEY } from '../modules/progress/slice';
import reportReducer, { REPORT_KEY } from '../modules/report/slice';
import { ROADMAP_KEY, roadmapSliceReducer } from '../modules/roadmap/slice';
import { ROUTE_KEY, routeSliceReducer } from '../modules/routeController/slice';
import settingReducer, { SETTING_KEY } from '../modules/setting/slice';
import {
    TOTAL_BET_KEY,
    totalBetsSliceReducer,
} from '../modules/totalBet/slice';
const rootReducer = combineReducers({
    [MAIN_KEY]: mainReducer,
    [SETTING_KEY]: settingReducer,
    [REPORT_KEY]: reportReducer,
    [PROGRESS_KEY]: progressReducer,
    [POPUP_KEY]: popupSliceReducer,
    [GAME_POPUP_KEY]: inGamePopupSliceReducer,
    [GAME_KEY]: gameSliceReducer,
    [GAME_LIVE_KEY]: LiveDataSliceReducer,
    [BET_ROOM_KEY]: betRoomSliceReducer,
    [BET_PLAYERS_KEY]: betPlayersSliceReducer,
    [BET_TABLE_KEY]: tableBetSliceReducer,
    [PHOST_KEY]: hostsSliceReducer,
    [PCOUNT_KEY]: countsSliceReducer,
    [LOBBY_KEY]: lobbySliceReducer,
    [ROUTE_KEY]: routeSliceReducer,
    [ROADMAP_KEY]: roadmapSliceReducer,
    [TOTAL_BET_KEY]: totalBetsSliceReducer,
    [LOBBY_ROOM_KEY]: lobbyRoomSliceReducer,
    [ROADMAP_TYPE_KEY]: roadmapTypeSliceReducer,
    [CHIPS_KEY]: chipsSliceReducer,
    [BET_GAME_KEY]: betGameSliceReducer,
    [LHOST_KEY]: hostLiveSliceReducer,
    [GOOD_ROAD_KEY]: goodRoadsSliceReducer,
    [ANALYTIC_KEY]: analyticSliceReducer,
    [BJ2_SEAT_KEY]: bj2SeatSliceReducer,
    [BJ2_HAND_KEY]: bj2HandSliceReducer,
    [ANIMATION_KEY]: animationSliceReducer,
});
export default rootReducer;
